export default __webpack_public_path__ + "static/media/gallery-wip-neck-ring_02.9c9cb0bb.jpg";